import { connect } from 'react-redux'

import { getCompanyLogoUrlSelector } from '../selectors'
import { TermsAndConditionsHeader } from '../components'

export default connect((state) => ({
  logoUrl: getCompanyLogoUrlSelector(state),
}))(TermsAndConditionsHeader)
